import TextInputColumnFilter from "../../../shared/table/TextInputColumnFilter";

export const TABLE_COLUMNS = [
  {
    Header: "Method",
    accessor: "method",
    Filter: TextInputColumnFilter,
  },
  {
    Header: "Additional Run Net Charge",
    accessor: "additionalRunChargeNet",
    Filter: TextInputColumnFilter,
  },
  {
    Header: "Actions",
    id: "Actions",
  },
];
